import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Dialog } from '@material-ui/core';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import DialogContent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogContent';
import { QueryVal } from 'Helpers/Query';
import Survey from 'Views/Onboarding/Pages/Survey';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { OnboardingHeaderProvider } from 'Views/Onboarding/Contexts/OnboardingHeaderContext';
import { OnboardingFooterProvider } from 'Views/Onboarding/Contexts/OnboardingFooterContext';

const styles = () => ({
  root: {
    maxHeight: '800px',
    minWidth: '360px',
  },
  content: {
    display: 'block',
    maxHeight: '800px',
    minWidth: '360px',
  },
});

export const CLOSE_ON_RESOURCE_TYPE_QUERY_PARAM_NAME = 'closeOnType';

const OnboardingPlannerViewSurveyModal = ({
  classes,
  className,
  onClose,
}) => {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Onboarding Planner View Survey Modal',
    isPageView: true,
  });

  const { getPrimaryClient } = useSimpleHousehold();

  const resourceTypeToCloseOn = QueryVal(CLOSE_ON_RESOURCE_TYPE_QUERY_PARAM_NAME);

  const onStepChange = (newResource) => {
    if (!resourceTypeToCloseOn || newResource.type() === resourceTypeToCloseOn) {
      onClose(newResource);
    }
  };

  return (
    <Dialog
      {...rootNodeProps}
      open
      maxWidth="lg"
      scroll="body"
      className={classNames(className, classes.root)}
      onClose={() => onClose()}
    >
      <DialogContent classes={classes.content}>
        <OnboardingHeaderProvider>
          <OnboardingFooterProvider>
            <Survey
              clientResource={getPrimaryClient()}
              onStepChange={onStepChange}
              showHeader={false}
              showNavbar={false}
              fixedFooter={false}
            />
          </OnboardingFooterProvider>
        </OnboardingHeaderProvider>
      </DialogContent>
    </Dialog>
  );
};

OnboardingPlannerViewSurveyModal.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

OnboardingPlannerViewSurveyModal.defaultProps = {
  className: '',
};

export default withStyles(styles)(OnboardingPlannerViewSurveyModal);
